import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { routerGuide } from '@/router/guideRouter';
import { storage } from '@/utils/storage';

const routes: Array<RouteRecordRaw> = [
  ...routerGuide,
  // 替代vue2中的'*'通配符路径
  { path: '/:pathMatch(.*)*', redirect: '/404' },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(), // hash 模式则使用 createWebHashHistory()
  routes,
});

router.beforeEach((to, from) => {
  if (to && to.meta && to.meta.title) document.title = String(to.meta.title);
  if (to.path === '/') {
    router.go(-1);
  }
});
router.beforeEach((to, from, next) => {
  const query = to.query;
  for (const i in query) {
    saveRouterValue(i, <string>query[i]);
  }
  next();
});
function saveRouterValue(name: string, value: string) {
  if (name) {
    if (name === 'yxToken' || name == 'defined') {
      name = 'token';
    }
    if (name === 'token') {
      storage.setItem(name, value, null, 2);
    } else {
      storage.setItem(name, value, null, 2);
    }
  }
}

export default router;
